import {} from '../groupA/script';
